<style scoped>
    body {
        background: white !important;
    }
    .table {
        margin-bottom: 0 !important;
    }
    table thead th, .btn {
    background-color: #0c2c77 !important;
    color: white;  
    }
</style>
<template>
    <CContainer>
        <CCard class="border-0 shadow rounded">
        <CCardHeader class="border-0"><h4 class="font-weight-bold">Data Kantor Akuntan Publik</h4></CCardHeader>
            <CCardBody>               
                <div class="form-row">
                    <div class="form-group col-md-5">
                        <label for="nama" class="font-weight-bold">Nama</label>
                        <input type="text" class="form-control" v-model="filter" placeholder="Cari Nama">
                    </div>
                    <div class="form-group col-md-5">
                        <label for="status" class="font-weight-bold">Status</label>
                        <select name="status" class="form-control" id="" v-model="statusAnggota">
                            <option value="aktif">Aktif</option>
                            <option value="tidak_aktif">Tidak Aktif</option>
                        </select>
                    </div>
                    <div class="form-group d-flex align-items-end col-md-2">
                        <button class="btn btn-md btn-primary px-4 mx-auto" @click="terapkanFilter"><font-awesome-icon icon="search" class="mr-2" /> Cari</button>
                    </div>
                </div>                
            </CCardBody>
        </CCard>

        <div class="mt-5">
            <h4 class="font-weight-bold mb-3">Data Kantor Akuntan Publik</h4>
            <table class="table table-striped table-hover">
                <thead>
                    <tr>
                        <th>No</th>
                        <th>No Izin KAP</th>
                        <th>Nama KAP</th>
                        <th class="text-center">Tanggal Izin KAP</th>
                        <th>KAPA/OAA</th>
                        <th>Kota/Kab</th>
                        <th>No Telepon</th>
                        <th class="text-center">Jumlah Anggota</th>
                        <th class="text-center">Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(value, index) in items" :key="index">
                        <td>{{index+1}}</td>
                        <td class="font-weight-bold">{{value.no_izin ? value.no_izin : '-'}}</td>
                        <td>{{value.nama_kap ? value.nama_kap : '-'}}</td>
                        <td class="text-center">{{value.tanggal_izin_kap ? value.tanggal_izin_kap : '-'}}</td>
                        <td>{{value.kapa ? value.kapa : '-'}}</td>
                        <td>{{value.kota_kab ? value.kota_kab : '-'}}</td>
                        <td>{{value.no_telephone ? value.no_telephone : '-'}}</td>
                        <td class="text-center">{{value.jumlah_anggota ? value.jumlah_anggota : '0'}}</td>
                        <td class="text-center font-weight-bold text-success" v-if="value.status == 1 || value.status == 'active'">Aktif</td>
                        <td class="text-center font-weight-bold text-danger" v-else>Tidak Aktif</td>
                    </tr>
                    <tr>
                        <td colspan="9" class="text-center font-weight-bold" v-if="items == [] || items == ''">Data Tidak Tersedia</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="bg-white row mt-2">
            <div class="col-md-12">
                <CPagination
                    style="float:right"
                    :active-page.sync="currentPage"
                    :pages="pagination.totalPages"
                    responsive
                    @click="pageChange"
                />
            </div>
        </div>
    </CContainer>
</template>
<script>
import DataAnggotaService from '@/services/web-view/data-anggota.service'
export default {
    data() {
        return {
            items: [],
            kategoriAnggota: 'default',
            statusAnggota: 'aktif',
            filter: '',
            currentPage: 0,
            pagination: {
                totalPages: 0
            },
        }
    },

    watch: {
        currentPage: function(val) {
        // alert(val-1);
        var page = val - 1;
        this.indexed = page * 10;
        // alert(this.indexed);
        this.getData(val - 1, this.pageSize, this.filter, this.filterKategori, this.statusAnggota);
        // this.getData(val-1);
        }
    },

    methods: {
        getData(currentPage, pageSize, filter, statusAnggota) {
        var vm = this
        DataAnggotaService.getDataAnggotaKap(
            currentPage,
            pageSize,
            filter,
            statusAnggota
        )
            .then((response) => {

            vm.items = response.data.data.content;
            vm.pagination.totalPages = response.data.data.totalPages;
            vm.currentPage = response.data.data.pageable.pageNumber + 1;
            })
            .catch((error) => {
            // comment console console.log(error);
            });
        },

        terapkanFilter() {
            this.getData('0', '10', this.filter, this.statusAnggota)
        }
    }
}   
</script>